import { NgModule } from '@angular/core';
import { AuthRoutingModule, routedComponents } from './auth-routing.module';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth-guard.service';
import { SadevLoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  imports: [
    AuthRoutingModule,
    FormsModule,
    SharedModule,
    // FormsModule,
    ReactiveFormsModule
  ],
  entryComponents: [
    SadevLoginComponent,
  ],
  declarations: [
    SadevLoginComponent,
    ...routedComponents,
  ],
  providers: [
    AuthService,
    AuthGuard
  ],
})
export class AuthModule { }
